import { ActionService } from 'dashboard-services';
import { globalActions } from 'primary-components';

export default (() =>  {

  const ADD_JOB_ID = 'ADD_JOB_ID_UPLOAD'
  const addJobId = ActionService.makeActionCreator(ADD_JOB_ID, 'jobId', 'displayName', 'subtitle', 'isDisabled')

  const ADD_FIELD = 'ADD_FIELD_UPLOAD'
  const addField = ActionService.makeActionCreator(ADD_FIELD)

  const REMOVE_FIELD = 'REMOVE_FIELD_UPLOAD'
  const removeField = ActionService.makeActionCreator(REMOVE_FIELD, 'index')

  const CHANGE_FIELD = 'CHANGE_FIELD_UPLOAD'
  const changeField = ActionService.makeActionCreator(CHANGE_FIELD, 'value', 'name', 'index')

  const uploadFile = ({ metadataCall, contentCall, fileToUpload, groupName, fileName, fileType, fields }) => dispatch =>
    metadataCall({
      groupName,
      fileName,
      fileType,
      fields
    })
    .then(response => {
      const jobId = response.headers.get("X-KH-JOB-ID")
      dispatch(addJobId(jobId, fileName, groupName, false))
      return response
    })
    .then(response => response.json())
    .then(response => contentCall({ url: response.location, image: fileToUpload }))
    .then(() => dispatch(globalActions.getMessageStore()).success("File has been saved."))

  return {
    uploadFile,
    addJobId,
    ADD_JOB_ID,
    addField,
    removeField,
    changeField,
    CHANGE_FIELD,
    REMOVE_FIELD,
    ADD_FIELD
  }
})()